import { INITIAL_PAGE } from '@repo/toolkit/constants/pagination'

import { PcrPayScaleTypeEnum } from '../../lib/types/enums/pcr-pay-scales/pcr-pay-scale-type.enum'
import { PcrPayScale } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'
import { getPcrPayScales } from './get-pcr-pay-scales'

export type LatestpayScale = {
  classifiedAmount: number
  interviewDoneAmount: number
}

export const getLatestPcrPayScale = async () => {
  const latestPayScaleByType = (payScales: PcrPayScale[], type: PcrPayScaleTypeEnum) =>
    payScales.find((payScale) => payScale.type === type)?.amount ?? 0

  const allPcrPayScales = await getPcrPayScales({
    page: INITIAL_PAGE,
    sort: { createdAt: 'desc' }
  })

  return {
    classifiedAmount: latestPayScaleByType(
      allPcrPayScales.data ?? [],
      PcrPayScaleTypeEnum.CLASSIFIED
    ),
    interviewDoneAmount: latestPayScaleByType(
      allPcrPayScales.data ?? [],
      PcrPayScaleTypeEnum.INTERVIEW_DONE
    )
  }
}
